/* Built In Imports */

/* External Imports */
import { Box, Image, useMediaQuery } from '@chakra-ui/react';
import { render } from 'datocms-structured-text-to-html-string';
/* Internal Imports */
import SimpleButton from '@components/Buttons/SimpleButton';
import StructuredTextParser from '@components/Utility/ArticleParser/StructuredTextParser';
/* Components */

/**
 * Renders the ImageBannerAd Card component
 *
 * @param sectionContent.sectionContent
 * @param {object} sectionContent - Data for section
 * @param {string} region - Region for page
 * @param {Sting} lang - Language for page
 * @param sectionContent.region
 * @param sectionContent.lang
 * @param sectionContent.width
 * @param sectionContent.height
 * @param sectionContent.my
 * @param sectionContent.display
 * @param sectionContent.maxW
 * @returns {ReactElement} ImageBannerAd component
 */
const OtherWays = ({ section, region, language }) => {
    return (
        <Box
            display={"flex"}
            flexDirection={{ base: "column", sm: "column", lg: "row" }}
            justifyContent="center"
            alignItems="center"
            padding={{ base: "50px 0px", sm: "50px 0px", lg: "43px 0px" }}
        >
            <Box>
                <Box
                    color={"black"}
                    fontWeight={"semibold"}
                    fontSize={{ base: "28px", sm: "28px", lg: "38px" }}
                    lineHeight={"1.2"}
                    marginRight={{ base: "0px", sm: "0px", lg: "62px" }}
                    textAlign={{ base: "center", sm: "center", lg: "left" }}
                    maxW={'278px'}
                >
                    {section[0]?.titleText}
                </Box>
                <Box marginTop={"10px"} display={{ base: 'flex', md: 'block' }} justifyContent={{ base: 'center', md: '' }}>
                    <Image src={section[1]?.image?.url} alt="" />
                </Box>
            </Box>
            <Box
                width={{ base: "320px", md: "400px", lg: "620px" }}
                marginTop={{ base: "32px", sm: "32px", lg: "0" }}
                background={"white"}
                fontSize={"16px"}
                fontWeight={"400"}
                padding={{ base: "32px 20px", sm: "32px 20px", lg: "55px" }}
                style={{
                    filter: "drop-shadow(0px 6px 14px rgba(0, 0, 0, 0.10)) drop-shadow(0px 25px 25px rgba(0, 0, 0, 0.09)) drop-shadow(0px 56px 33px rgba(0, 0, 0, 0.05)) drop-shadow(0px 99px 40px rgba(0, 0, 0, 0.01)) drop-shadow(0px 154px 43px rgba(0, 0, 0, 0.00))"
                }}
            >
                <Box
                    fontFamily="FedraSerifAStdBook"
                    fontWeight={'600'}
                    fontSize={"20px"}
                    color={"black"}
                    maxW={{ base: '216px', md: '100%' }}
                    m={{ base: '0 auto', md: '0' }}
                    textAlign={{ base: "center", sm: "center", lg: "start" }}
                >
                    {section[2]?.text}
                </Box>
                <Box
                    fontFamily="FedraSansStd-book"
                    fontSize={"16px"}
                    margin={"10px 0px 20px 0px"}
                    color={"#676055"}
                    lineHeight={'24px'}
                    width={{ base: '100%', md: '403px' }}
                    textAlign={{ base: "center", sm: "cemter", lg: "start" }}
                >
                    <StructuredTextParser str={render(section[3]?.body)} textAlign={{ base: 'center', md: 'left' }} />
                </Box>
                <Box marginTop="20px" display={"flex"} justifyContent={{ base: "center", sm: "center", lg: "start" }}
                    alignItems={{ base: "center", sm: "center", lg: "start" }}
                >
                    <Box textAlign={"left"} >
                        <SimpleButton
                            style={section[4]}
                            mb="5px"
                            targetwindow="_blank"
                        />
                    </Box>
                </Box>
                <Box
                    display={"flex"}
                    flexDirection={{ base: "column", sm: "column", lg: "row" }}
                    alignItems={{ base: "center", sm: "start", lg: "start" }}
                    justifyContent={{ base: "center", sm: "start", lg: "start" }}
                    fontFamily="FedraSansStd-book"
                    fontSize={"14px"}
                    color={"#676055"}
                    className='textlink'
                >
                    <StructuredTextParser className="corpuslink" str={render(section[5]?.body)} textAlign={{ base: 'center', md: 'left' }} maxW={{ base: '180px', md: '100%' }} />
                </Box>
            </Box>
            <style jsx global>
                {`
                    @media (max-width: 767px) {
                        .corpuslink {
                            width: 197px;
                        }
                    }
                `}
            </style>
        </Box >
    );
};

export default OtherWays;
